module.exports = __webpack_public_path__ + "img/t1.7c05e87f.png";